import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "height"
const HeightIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M19.5 22.5H4.5V21H19.5zM15.905 8.47 14.845 9.53 12.75 7.436V16.564L14.845 14.47 15.905 15.53 12 19.436 8.095 15.53 9.155 14.47 11.25 16.564V7.436L9.155 9.53 8.095 8.47 12 4.564zM19.5 3H4.5V1.5H19.5z" />
        </svg>
      }
    </span>
  )
}
export default HeightIcon
